import type { NavigationEntry } from "@positive/ui";
import "@ui5/webcomponents-icons/dist/collaborate.js";
import "@ui5/webcomponents-icons/dist/connected.js";
import "@ui5/webcomponents-icons/dist/customer.js";
import "@ui5/webcomponents-icons/dist/discussion.js";
import "@ui5/webcomponents-icons/dist/feedback.js";
import "@ui5/webcomponents-icons/dist/group.js";
import "@ui5/webcomponents-icons/dist/message-popup.js";
import "@ui5/webcomponents-icons/dist/request.js";

import { msgPermissions } from "./permissions";

/** Messaging entries of the navigation registry (group `messaging`, plan module `msg`). */
export const msgNavigation: readonly NavigationEntry[] = [
  {
    key: "msg.monitor",
    labelKey: "nav.msgMonitor",
    icon: "message-popup",
    path: "/msg/monitor",
    permission: msgPermissions.outgoingView,
  },
  {
    key: "msg.segments",
    labelKey: "nav.msgSegments",
    icon: "group",
    path: "/msg/segments",
    permission: msgPermissions.segmentView,
  },
  {
    key: "msg.consent",
    labelKey: "nav.msgConsent",
    icon: "customer",
    path: "/msg/consent",
    permission: msgPermissions.consentView,
  },
  {
    key: "msg.surveys",
    labelKey: "nav.msgSurveys",
    icon: "feedback",
    path: "/msg/surveys",
    permission: msgPermissions.surveyView,
  },
  {
    key: "msg.triggers",
    labelKey: "nav.msgTriggers",
    icon: "request",
    path: "/msg/triggers",
    permission: msgPermissions.triggerView,
  },
  {
    key: "msg.templates",
    labelKey: "nav.msgTemplates",
    icon: "collaborate",
    path: "/msg/templates",
    permission: msgPermissions.templateView,
  },
  {
    key: "msg.accounts",
    labelKey: "nav.msgAccounts",
    icon: "connected",
    path: "/msg/accounts",
    permission: msgPermissions.accountView,
  },
];
